import { useTranslation } from "react-i18next";

export default function FoundersMessage() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-deepblack py-24 md:py-36 overflow-hidden">
      {/* Subtle top gradient line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] max-w-2xl h-px bg-gradient-to-r from-transparent via-champagne/20 to-transparent" />

      <div className="w-full px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl mx-auto">
          {/* Label */}
          <span className="text-warmgray text-xs font-sans tracking-widest uppercase block mb-6 text-center">
            {t("foundersMessage.label")}
          </span>

          {/* Title — big prominent single line */}
          <div className="flex flex-col items-center mb-14 md:mb-20">
            {/* Top decorative line */}
            <div className="flex items-center gap-4 mb-5">
              <span className="w-12 h-px bg-gradient-to-r from-transparent to-champagne/60" />
              <span className="w-2 h-2 rounded-full bg-champagne/80" />
              <span className="w-12 h-px bg-gradient-to-l from-transparent to-champagne/60" />
            </div>
            <div className="relative">
              {/* Stronger glow behind */}
              <div className="absolute -inset-8 rounded-full bg-champagne/10 blur-3xl" />
              <h2 className="relative text-marble font-serif text-xl md:text-4xl lg:text-5xl xl:text-6xl font-normal tracking-normal md:tracking-wider whitespace-nowrap">
                {t("foundersMessage.title")}
              </h2>
            </div>
            {/* Bottom decorative line */}
            <div className="flex items-center gap-4 mt-5">
              <span className="w-12 h-px bg-gradient-to-r from-transparent to-champagne/60" />
              <span className="w-2 h-2 rounded-full bg-champagne/80" />
              <span className="w-12 h-px bg-gradient-to-l from-transparent to-champagne/60" />
            </div>
          </div>

          {/* Message body */}
          <div className="relative">
            {/* Decorative quote mark */}
            <i className="ri-double-quotes-l text-champagne/30 text-5xl md:text-6xl absolute -top-8 -left-2 md:-left-4 block" />

            <div className="text-warmgray text-sm md:text-base font-sans leading-loose tracking-wide whitespace-pre-line pl-6 md:pl-10 space-y-5">
              <p>{t("foundersMessage.p1")}</p>
              <p>{t("foundersMessage.p2")}</p>
              <p>{t("foundersMessage.p3")}</p>
              <p>{t("foundersMessage.p4")}</p>
              <p>{t("foundersMessage.p5")}</p>
            </div>
          </div>

          {/* Bottom accent line */}
          <div className="mt-16 md:mt-20 flex items-center justify-center gap-3">
            <span className="w-8 h-px bg-champagne/40" />
            <span className="w-1 h-1 rounded-full bg-champagne/60" />
            <span className="w-8 h-px bg-champagne/40" />
          </div>
        </div>
      </div>
    </section>
  );
}